import { memo } from 'react';
import { AdvancedCoursesTable } from './AdvancedCoursesTable';
import type { CourseDetail } from './CourseDetailModal';

type Course = CourseDetail;

interface CoursesTabProps {
  userCourses: Course[];
  loadingCourses: boolean;
  onEditCourse: (course: Course) => void;
}

export const CoursesTab = memo<CoursesTabProps>(
  ({ userCourses, loadingCourses, onEditCourse }) => {
    return (
      <AdvancedCoursesTable
        userCourses={userCourses}
        loadingCourses={loadingCourses}
        onEditCourse={onEditCourse}
      />
    );
  }
);

CoursesTab.displayName = 'CoursesTab';
